// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Guideline } from './guideline';
import { Supplier } from './supplier';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class GuidelineSupplier extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key FK guideline */
  guidelineId!: string;
  /** Guid key FK supplier */
  supplierId!: string;
  /** FK guidelineId */
  guideline!: Guideline;
  /** FK supplierId */
  supplier!: Supplier;
}

